import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { bell_01 } from "@tql/ui-components-react/untitled/icons";

// import { formatCurrency } from "~/shared/utils/string-fns.ts";
import styles from "./summary-count-indicator.module.css";

type SummaryCountIndicatorProps = {
	count: number | undefined;
	amount?: number;
	showAsCurrency?: boolean;
};

export const SummaryCountIndicator = ({
	count,
	amount,
	showAsCurrency = false,
}: SummaryCountIndicatorProps) => {
	if (
		(count === undefined || count <= 0) &&
		(!showAsCurrency || amount === undefined)
	)
		return null;

	// temp short circuit while we find a way to get pending amounts
	if (showAsCurrency) return null;

	return (
		<div className={styles.iconBox} role={"status"}>
			{showAsCurrency && amount !== undefined ? null : (
				<>
					<SvgIcon className={styles.icon} icon={bell_01} />
					<span className={styles.iconNumber}>{count}</span>
				</>
			)}
		</div>
	);
};
